/**
 * Compact display of weapons for list views.
 * Examples: "Spada", "Spada + Fioretto", "Spada +2", "Fioretto, Spada, Sciabola".
 */
function activeUnique(items = []) {
  const active = (items || []).filter((w) => w.status === "attiva" || w.status === "secondaria");
  active.sort((a, b) => (a.is_primary ? -1 : b.is_primary ? 1 : 0));
  return Array.from(new Map(active.map((w) => [w.weapon_code, w])).values());
}

export function summarizeWeapons(items = [], maxInline = 2) {
  const active = activeUnique(items);
  if (active.length === 0) return "Arma non impostata";
  if (active.length === 1) return cap(active[0].weapon_code);
  if (active.length === 2) return `${cap(active[0].weapon_code)} + ${cap(active[1].weapon_code)}`;
  if (active.length === maxInline + 1) return active.map((w) => cap(w.weapon_code)).join(", ");
  return `${cap(active[0].weapon_code)} +${active.length - 1}`;
}

function cap(s) { return (s || "").charAt(0).toUpperCase() + (s || "").slice(1); }

export default function WeaponSummary({ weapons = [] }) {
  const active = activeUnique(weapons);
  return (
    <div className="flex flex-wrap gap-1 items-center" data-testid="weapon-summary">
      {active.length === 0 && <span className="text-xs text-zinc-400" data-testid="weapon-none">Arma non impostata</span>}
      {active.map((w, i) => (
        <span
          key={w.id || `${w.weapon_code}-${i}`}
          data-testid={`weapon-tag-${w.weapon_code}${w.is_primary ? "-primary" : ""}`}
          className={`text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded border ${
            w.is_primary
              ? "bg-black text-white border-black"
              : "bg-zinc-50 text-zinc-700 border-zinc-300"
          }`}
        >
          {cap(w.weapon_code)}
        </span>
      ))}
    </div>
  );
}
